export default __webpack_public_path__ + "static/media/colorIcon.ae01b208.svg";